import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Datepicker from 'shared/components/Datepicker';
import Search from 'components/Search';

import styles from 'styles/components/TopPanel';

@withStyles(styles)
@observer
export default class TopPanel extends Component {

  render() {
    const { classes } = this.props;

    return (
      <AppBar position='fixed' color='default' elevation={1} >
        <Toolbar className={ classes.toolbar }>
          <div className={ classes.fullWidth }>
            <Search />
          </div>
          <div>
            <Datepicker />
          </div>
        </Toolbar>
      </AppBar>
    );
  }


}



// WEBPACK FOOTER //
// ./src/components/TopPanel.js